import React, { useState } from "react";
import { Chip, Stack } from "@mui/material";

type ExpandableChipsProps = {
  values: string[];
  maxVisible?: number;
};

export const ExpandableChips: React.FC<ExpandableChipsProps> = ({ values, maxVisible = 3 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!values || values.length === 0) return null;

  const visibleChips = expanded ? values : values.slice(0, maxVisible);
  const hiddenCount = values.length - maxVisible;

  return (
    <Stack
      direction="row"
      spacing={0.5} // horizontal spacing
      flexWrap="wrap"
      sx={{ rowGap: 0.5 }} // vertical spacing between rows of chips
    >
      {visibleChips.map((val, idx) => (
        <Chip key={val + idx} label={val} size="small" />
      ))}
      {!expanded && hiddenCount > 0 && (
        <Chip
          label={`+${hiddenCount} more`}
          size="small"
          color="primary"
          onClick={() => setExpanded(true)}
        />
      )}
      {expanded && values.length > maxVisible && (
        <Chip
          label="Less"
          size="small"
          color="secondary"
          onClick={() => setExpanded(false)}
        />
      )}
    </Stack>
  );
};